
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/utils/google-otp-secret",
      function () {
        return require("private-next-pages/utils/google-otp-secret.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/utils/google-otp-secret"])
      });
    }
  